module.exports = __webpack_public_path__ + "pk.svg?5420525e6dd2b93e66e990da29a7422a";